export const PageString = {
	Showcase: 'Showcase',
	Layers: 'Layers',
	Components: 'Components',
};
